import { gql } from "@apollo/client"

export const UPDATE_TRIP = gql`
  mutation updateTrip(
    $tripId: ID
    $vehicleId: ID
    $status: String
    $date: Date
  ) {
    updateTripDetails(
      trip: $tripId
      vehicleId: $vehicleId
      status: $status
      date: $date
    ) {
      trip {
        id
        date
        status
        vehicle {
          id
          registrationNumber
        }
      }
    }
  }
`
